import React from "react";
const MediaContext = React.createContext(undefined);
export default MediaContext;
